import type { JSX } from 'preact';
import { cn } from '../lib/cn';

export function Card({
  class: cls,
  ...rest
}: JSX.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      {...rest}
      class={cn(
        'rounded-lg border border-surface-muted/20 bg-surface p-4',
        cls as string | undefined,
      )}
    />
  );
}
